export default "__VITE_ASSET__BMArxU3s__"